import {
    Card,
    CardContent,
    CardDescription,
    CardFooter,
    CardHeader,
    CardTitle,
} from "@/components/ui/card"
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";

import { BrainCircuit,Crosshair,ScrollText,Search,Store } from "lucide-react";

const testimonialsData = [
    {
        text:"Me ayudo a descubrir que mi supermercado de siempre no era el más barato, y que otro que yo ni sabia que tenia despacho a mi comuna y gratis, ¡si lo era!",
        location:"Colina",
        name:"Maria Alejandra Ossa",
        instagram:"@maleossa",
        avatar:"Easton"
    },
    {
        text:"Desde que uso Carri, puedo ver todas las ofertas disponibles en ese momento y compararlas entre supermercados. Me permitió comprar con más información, sin esfuerzo y realmente ahorrar. Se nota que escuchan a los usuarios.",
        location:"Colina",
        name:"Eduardo Tello",
        instagram:"@edu_tello",
        avatar:"Destiny"
    },    
    {
        text:"Excelente aplicación, permite optimizar las compras, es una excelente herramienta",
        location:"Providencia",
        name:"Loreto Bravo",
        instagram:"@loreto.bravo.contreras",
        avatar:"Adrian"
    },    
    {
        text:"Esta pagina es una maravilla, me ha permitido hacer ahorros considerables en la compra mensual!! Y aprovechar las ofertas de productos que son mas \"de lujo\". 100% recomendada 😍",
        location:"Las Condes",
        name:"Maria Cecilia Ruiz",
        instagram:"@chechii_ruiz",
        avatar:"Wyatt"
    },    
    {
        text:"Use Carri y me facilitó la vida para comparar los precios de los productos habituales que compro de manera fácil y rápida",
        location:"Colina",
        name:"Catalina Seyler",
        instagram:"@cata.seyler",   
        avatar:"Riley"
    },    
,    
    {
        text:"Me encantó la aplicación, fácil de usar, te permite ahorrar bastante y visualizar donde se encuentran los menores precios de los productos. Vale la pena utilizarla en vez de una aplicación de supermercado ya que ahorras y demoras el mismo tiempo en hacer la compra. La recomiendo 100%",
        location:"Colina",
        name:"Loreto Olate",
        instagram:"@loreto_olate",  
        avatar:"Liam"
    },    
]


export const Testimonials = () => {
    return (

        
    <Carousel
        opts={{
            align: "start",
            loop: true,
            

        }}
        className="w-full max-w-[90dvw] lg:max-w-[90dvw] m-auto"
    > 
        <CarouselContent>        
        {
            testimonialsData.map((testimonial, index) => (
            <CarouselItem key={index} className="basis-1/1 xl:basis-1/4 lg:basis-1/3">
                <Card className="text-center min-w-72 max-w-72 min-h-[15rem] gap-2" key={index}>
                    <CardContent className="flex  flex-col w-full justify-left items-start">
                        <p className="text-xs text-left">
                            "{testimonial?.text}"
                        </p>
                    </CardContent>
                    <CardFooter className="mt-auto flex-row gap-2">
                        <img src={`https://api.dicebear.com/9.x/lorelei/svg?seed=${testimonial?.avatar}`} alt="Avatar" width="45"/>
                        <p className="text-xs font-semibold text-muted-foreground text-left">{testimonial?.name}<br/>
                        <span className="text-primary/80">{testimonial?.location}</span>
                        </p>
                    </CardFooter>
                </Card>               
            </CarouselItem>
            ))
        }                
        </CarouselContent>
        {/* <CarouselPrevious />
        <CarouselNext />  */}
    </Carousel>
    );
}